import React from "react";
import Page from "../templates/support/environment/environment";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          Coastal and Mangrove projects | Environment protection | Hirdaramani
        </title>
        <meta
          name="title"
          content="Coastal and Mangrove projects | Environment protection | Hirdaramani"
        />
        <meta
          name="description"
          content="Hirdaramani links community and environment, driving projects and supporting local initiatives, engaging schools and children for a sustainable future."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/support/environment/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Coastal and Mangrove projects" />
        <meta
          property="og:title"
          content="Coastal and Mangrove projects | Environment protection | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Hirdaramani links community and environment, driving projects and supporting local initiatives, engaging schools and children for a sustainable future."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/support/environment/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
